import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetSingleClient = async (bid = getLocalStorageItem("bid")) => {
  /**
   * input: null
   * output: client object
   * description: fetches Single client
   */

  try {
    const clientsDocument = await doc(db, "clients", bid);

    const clientSnapshot = await getDoc(clientsDocument);

    const client = { ...clientSnapshot.data(), id: clientSnapshot.id };
    return client;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleClient;
